import { Space, Table } from 'antd';
import styled, { css } from 'styled-components';

export const TableWrapper = styled(Table)`
  ${props =>
    props.className?.includes('kit-table')
      ? css`
          height: 85%;
        `
      : props.className?.includes('fixed-column')
        ? css`
          .ant-table-body {
            overflow-y: scroll !important;
          }
        `
        : null}
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: end;

  padding: 16px 8px;

  &.separator {
    border-top: 1px solid var(--light-gray);
  }

  .custom-select {
    margin-left: 8px;

    .ant-select-selector {
      padding: 0 12px;

      border-radius: 16px;
      border-color: var(--link);
      background: var(--light-link);
    }

    .ant-select-selection-item {
      color: var(--link);
    }

    .ant-select-arrow svg {
      width: 11px;
    }
  }

  .ant-pagination-next,
  .ant-pagination-prev {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 6px;
    }

    &.ant-pagination-disabled svg {
      opacity: 0.6;
    }

    &:not(.ant-pagination-disabled):hover {
      background-color: rgba(0, 0, 0, 0.06);
    }
  }
`;

export const SizeChangerWrapper = styled.div`
  > .custom-select {
    margin-left: auto;
  }
`;

export const CustomTotal = styled.div`
  color: var(--color);

  .total {
    font-weight: 600;
  }
`;

export const AmiliPaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 8px;

  border-top: 1px solid var(--light-gray);

  @media screen and (max-width: 768px) {
    justify-content: center;
    padding-block: 2.4rem;
  }
`;

export const AmiliPagesWrapper = styled(Space)`
  justify-content: center;
`;

export const AmiliPageWrapper = styled.div`
  border: 1px solid var(--secondary);
  border-radius: 16px;
  padding-inline: 10px;
  min-width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
  }

  &.active {
    background-color: var(--secondary);
    color: white;
    font-weight: 500;
  }

  @media screen and (max-width: 768px) {
    min-width: 6.4rem;
    height: 6.4rem;
    padding-inline: 1rem;
  }
`;

export const AmiliArrowButton = styled(AmiliPageWrapper)`
  border-color: transparent;

  &.disabled {
    cursor: not-allowed;

    svg {
      opacity: 0.6;
    }

    &:hover {
      background-color: transparent;
    }
  }
`;
